// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"340":"6db6ca4f","787":"aadca95f"}[chunkId] + ".chunk.js";
};